module.exports = __webpack_public_path__ + "static/media/mixkit-bell-notification-933.d8653ed1.wav";